import { UseMutationResult } from "@tanstack/react-query";
import { Form, Formik, FormikValues } from "formik";

import { Loader, Button, ButtonsWrapper } from "components/elements";
import { FormStatus } from "components/form";
import {
  CheckboxGroupField,
  RadioGroupField,
  TextField,
} from "components/form/fields";
import { PageContent, PageHeader, TabContent } from "components/layout";
import { ApiResponse } from "types/api";
import { FieldProps } from "types/form";

import { TEXTS } from "../constants";
import { TiVoDeviceTab, TiVoDeviceTabs } from "./TiVoDeviceTabs";

function renderField(field: FieldProps) {
  if (field.type === "checkbox") {
    return <CheckboxGroupField {...field} key={`checkbox-${field.name}`} />;
  }
  if (field.type === "radio") {
    return <RadioGroupField {...field} key={`radio-${field.name}`} />;
  }
  return <TextField {...field} key={`text-${field.name}`} />;
}

interface TiVoDeviceFormProps<T> {
  fields: FieldProps[];
  formData: FormikValues & T;
  header: string;
  loading?: boolean;
  onSubmit: (values: T) => void;
  tabs: TiVoDeviceTab[];
  updateData: UseMutationResult<ApiResponse<T>, Error, any>;
}

export function TiVoDeviceForm<T>({
  fields,
  formData,
  header,
  loading = false,
  onSubmit,
  tabs,
  updateData,
}: TiVoDeviceFormProps<T>) {
  return (
    <>
      <PageHeader>{header}</PageHeader>
      <PageContent>
        <TiVoDeviceTabs tabs={tabs} />
        <TabContent>
          {loading ? (
            <Loader />
          ) : (
            <Formik
              initialValues={formData}
              onSubmit={onSubmit}
              enableReinitialize={true}
            >
              {({ dirty, isSubmitting }) => (
                <>
                  <FormStatus submitMutations={[updateData]} withErrorDetails />
                  <Form>
                    {fields.map((field) => renderField(field))}
                    <ButtonsWrapper>
                      <Button
                        buttonType="submit"
                        type="green"
                        disabled={!dirty}
                        processing={isSubmitting}
                      >
                        {TEXTS.SUBMIT_BTN}
                      </Button>
                    </ButtonsWrapper>
                  </Form>
                </>
              )}
            </Formik>
          )}
        </TabContent>
      </PageContent>
    </>
  );
}
